import { useEffect, useState } from "react";
import PageTitleComponent from "../PageTitle";
import DashboardOverviewComponent from "./overview";
import RecentOrdersComponent from "./recentOrders";
import requestHandler from "../../utils/requestHandler";
import endpointsPath from "../../constants/EndpointsPath";

export default function DashboardComponent() {
  const [totalProducts, setTotalProducts] = useState(0);
  const [totalOrders, setTotalOrders] = useState(0);
  const [pendingShipping, setPendingShipping] = useState(0);
  const [registeredUsers, setRegisteredUsers] = useState(0);

  useEffect(() => {
    const getStats = async () => {
      const [products, users, orders, pShipping] = await Promise.all([
        requestHandler.get(`${endpointsPath.product}`, true),
        requestHandler.get(`${endpointsPath.user}`, true),
        requestHandler.get(`${endpointsPath.order}?pageSize=10&pageNumber=1`, true),
        requestHandler.get(`${endpointsPath.shipping}?status=Pending`, true),
      ]);

      if (products.statusCode === 200) setTotalProducts(products.result.totalRecords);
      if (users.statusCode === 200) setRegisteredUsers(users.result.totalRecords);
      if (orders.statusCode === 200) setTotalOrders(orders.result.totalRecords);
      if (pShipping.statusCode === 200) setPendingShipping(pShipping.result.totalRecords);
    };

    getStats();
  }, []);

  return (
    <div>
      <PageTitleComponent title="Dashboard" />
      <DashboardOverviewComponent
        totalProducts={totalProducts}
        totalOrders={totalOrders}
        registeredUsers={registeredUsers}
        pendingShipping={pendingShipping}
      />
      <RecentOrdersComponent />
    </div>
  );
}
